import { Injectable } from '@angular/core';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Userclass } from '../Classes/Userclass';


@Injectable()
export class UserService {
  constructor(private http: Http) { }

  GetAllUserdetails() {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.get('api/Users/GetAllUserdetails',options)
      .map((res: Response) => res.json());
  }

  GetPunchImagesbyDate(pDate:string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let OrgDetails = { "pDate": JSON.stringify(pDate)};
    let options: RequestOptions = new RequestOptions({ headers: headers, params: OrgDetails });
    return this.http.get('api/IFUsers/Get_UserPunchDetailsbyDate', options)
      .map((res: Response) => res.json());
  }

  Get_OrgDetails(mQuery: string, mQuerysecond: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let OrgDetails = { "mQuery": JSON.stringify(mQuery), "mQuerysecond": JSON.stringify(mQuerysecond) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: OrgDetails });
    return this.http.get('api/IFUsers/Get_OrgDetails', options)
      .map((res: Response) => res.json());
  }

  GetAllRoles() {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.get('api/Users/GetAllRoles', options)
      .map((res: Response) => res.json());
  }

  SaveUserDetails(_user: Userclass) {
    let body: string = JSON.stringify(_user);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.post('api/Users/SaveUserDetails', body, options)
      .map((res: Response) => res.json());
  }
  //Tenantid: string, Hotelid: string,
  //"Tenantid": JSON.stringify(Tenantid), "HotelId": JSON.stringify(Hotelid), 
  deleteFailedPunch( Uniqueno: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let PunchDetails = {"Uniqueno": JSON.stringify(Uniqueno)};
    let options: RequestOptions = new RequestOptions({ headers: headers, params: PunchDetails });
    return this.http.get('api/IFUsers/deleteFailedPunch', options)
      .map((res: Response) => res.json());
  }

}




// WEBPACK FOOTER //
// ./src/app/Services/UserService.ts